const STORAGE_KEY = 'agentepro_reminders';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Registra il service worker
export async function registerSW() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
    return reg;
  } catch { return null; }
}

// Richiede permesso notifiche
export async function requestPermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

export function getPermissionStatus() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}

// Converte base64url → Uint8Array (per applicationServerKey)
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map((c) => c.charCodeAt(0)));
}

// Iscrive il browser alle push notifications e salva il reminder sul backend
export async function subscribePushReminder(aptId, reminderTime, clientName) {
  try {
    if (!('PushManager' in window) || !('serviceWorker' in navigator)) return false;
    const reg = await navigator.serviceWorker.ready;

    // Recupera la VAPID public key dal backend
    const keyRes = await fetch(`${BACKEND_URL}/api/push/public-key`);
    const { public_key } = await keyRes.json();

    // Ottieni o crea la subscription push
    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(public_key),
      });
    }

    const json = subscription.toJSON();
    // Invia subscription + reminder al backend
    await fetch(`${BACKEND_URL}/api/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        endpoint: json.endpoint,
        p256dh: json.keys.p256dh,
        auth: json.keys.auth,
        apt_id: aptId,
        reminder_time: reminderTime instanceof Date ? reminderTime.toISOString() : reminderTime,
      }),
    });

    // Salva anche in localStorage come backup (per notifiche locali)
    saveReminder(aptId, clientName, reminderTime);
    // Schedule locale (funziona quando app è aperta/background)
    scheduleLocalReminder(aptId, clientName, reminderTime);
    return true;
  } catch (err) {
    console.error('Push subscription failed:', err);
    // Fallback: usa solo notifiche locali
    saveReminder(aptId, clientName, reminderTime);
    scheduleLocalReminder(aptId, clientName, reminderTime);
    return true;
  }
}

// Rimuove il reminder
export async function removeReminder(aptId) {
  const reminders = getStoredReminders();
  delete reminders[aptId];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(reminders));
  try {
    await fetch(`${BACKEND_URL}/api/push/subscribe/${aptId}`, { method: 'DELETE' });
  } catch {}
  if ('serviceWorker' in navigator) {
    const reg = await navigator.serviceWorker.ready.catch(() => null);
    reg?.active?.postMessage({ type: 'CANCEL_NOTIFICATION', id: String(aptId) });
  }
}

function saveReminder(aptId, label, reminderTime) {
  const reminders = getStoredReminders();
  reminders[aptId] = { label, reminderTime: reminderTime instanceof Date ? reminderTime.toISOString() : reminderTime };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(reminders));
}

async function scheduleLocalReminder(aptId, label, reminderTime) {
  if (Notification.permission !== 'granted') return;
  const reg = await navigator.serviceWorker.ready.catch(() => null);
  if (!reg?.active) return;
  const delay = new Date(reminderTime).getTime() - Date.now();
  if (delay > 0 && delay < 24 * 60 * 60 * 1000) {
    reg.active.postMessage({
      type: 'SCHEDULE_NOTIFICATION',
      id: String(aptId),
      title: '📅 venditoreElite – Visita',
      body: label,
      delay,
    });
  }
}

export function hasReminder(aptId) {
  return !!getStoredReminders()[aptId];
}

export function getStoredReminders() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); } catch { return {}; }
}

// Chiamato all'avvio: ri-schedula reminder locali pendenti
export async function scheduleReminders() {
  if (!('serviceWorker' in navigator) || Notification.permission !== 'granted') return;
  const reg = await navigator.serviceWorker.ready.catch(() => null);
  if (!reg?.active) return;
  const reminders = getStoredReminders();
  const now = Date.now();
  Object.entries(reminders).forEach(([aptId, reminder]) => {
    const target = new Date(reminder.reminderTime).getTime();
    const delay = target - now;
    if (delay < -5 * 60 * 1000) {
      const r = getStoredReminders(); delete r[aptId]; localStorage.setItem(STORAGE_KEY, JSON.stringify(r));
    } else if (delay >= 0 && delay <= 24 * 60 * 60 * 1000) {
      reg.active.postMessage({
        type: 'SCHEDULE_NOTIFICATION',
        id: String(aptId),
        title: '📅 venditoreElite – Visita',
        body: reminder.label,
        delay: Math.max(0, delay),
      });
    }
  });
}
